import { useMemo, useContext ,memo} from "react";
import { useLocation } from "react-router-dom";

import { normalizePath } from "../../utills";
import RenderIfAvailable from "../RenderIfAvailable";
import HelpWidgetsIcn from "./components/HelpWidgetsIcn";
import { TransAndConfigContext } from "../../context/ConfigAndTranslationContext";

const HelpFloatingWidget = () => {
  const location = useLocation();
  const { globalConfig: { helpAndWidgetsConfig = {} } = {} } = useContext(TransAndConfigContext) ?? {};

  const widgetConfig = useMemo(() => {
    const currentPath = normalizePath(location?.pathname);
    return {
      isWidgetsEnable: helpAndWidgetsConfig?.noWidgetsIcn?.indexOf(currentPath) === -1,
      isWhatsAppEnable: helpAndWidgetsConfig?.noWhatsappOption?.indexOf(currentPath) === -1,
      isCallBackEnable: helpAndWidgetsConfig?.noCallbackOption?.indexOf(currentPath) === -1
    }
  }, [helpAndWidgetsConfig,location])

  return <>
    <RenderIfAvailable value={helpAndWidgetsConfig?.enable && widgetConfig?.isWidgetsEnable}>
      <HelpWidgetsIcn configData={{
        ...helpAndWidgetsConfig,
        isWhatsAppEnable: widgetConfig?.isWhatsAppEnable,
        isCallBackEnable: widgetConfig?.isCallBackEnable
      }} />
    </RenderIfAvailable>
  </>
};

export default memo(HelpFloatingWidget);